import React, { useEffect, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import { useCanAccessCustomerService } from '@/hooks/useCanAccessCustomerService';
import { toast } from 'sonner';

interface Props {
  children: React.ReactNode;
}

export function CustomerServiceRoute({ children }: Props) {
  const { canAccess, isLoading } = useCanAccessCustomerService();
  const notified = useRef(false);

  useEffect(() => {
    if (!isLoading && !canAccess && !notified.current) {
      notified.current = true;
      toast.error('Você não tem acesso ao Atendimento.');
    }
  }, [isLoading, canAccess]);

  if (isLoading) {
    return <div className="p-3 text-sm text-muted-foreground">Carregando...</div>;
  }

  if (!canAccess) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
